import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

import "./BurgerMenu.scss";
import { FcHome } from "react-icons/fc";
import { FcMusic } from "react-icons/fc";

import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import HelpDropdown from "../HelpDropdown/HelpDropdown.js";

const BurgerMenu = () => {
  const { user, logoutUser } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="burger">
      <button className="burger__icon" onClick={toggleMenu}>
        <div className="burger__line"></div>
        <div className="burger__line"></div>
        <div className="burger__line"></div>
      </button>
      <nav className={`menu ${isOpen ? "open" : ""}`}>
        <div>
          <p className="menu__close" onClick={closeMenu}>
            &times;
          </p>
        </div>
        <ul>
          <Link to={"/"} className="burger__nav-item" onClick={closeMenu}>
            <li>
              Home
              <FcHome />
            </li>
          </Link>

          <Link
            to={"/stories"}
            className="burger__nav-item"
            onClick={closeMenu}
          >
            <li>Stories</li>
          </Link>

          <HelpDropdown
            variant="bare"
            // className="burger__nav-item"

            // onClick={closeMenu}
          />

          {/* <select name="Help" id="100" required>
            {" "}
            <option value={"Help"}>Help</option>
            <option value={"Grief Therapists"}>Grief Therapists</option>
            <option value={"Grief Resources"}>Grief Resources</option>
          </select> */}

          {/* <Link
            to={"/medHelp"}
            className="burger__nav-item"
            onClick={closeMenu}
          >
            <li>Grief Resources</li>
          </Link> */}

          <Link to={"/songs"} className="burger__nav-item" onClick={closeMenu}>
            <li>
              Rhythms <FcMusic />
            </li>
          </Link>

          <Link to={"/about"} className="burger__nav-item" onClick={closeMenu}>
            <li>About</li>
          </Link>

          {/* <Link to={"/login"} className="burger__nav-item" onClick={closeMenu}>
            <li>Login</li>
          </Link> */}

          {!user && (
            <Link
              to={"/login"}
              className="burger__nav-item"
              onClick={closeMenu}
              // style={navLinkStyles}
            >
              {/* Show Login only if no user is logged in */}
              {/* {!user && <li>Login</li>} */}

              <li>Login</li>
            </Link>
          )}

          {/* Show Logout only if user IS logged in */}

          {user && (
            <li
              className="burger__nav-item"
              onClick={logoutUser}
              style={{ cursor: "pointer" }}
            >
              Logout
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default BurgerMenu;
